import './bootstrap';
import * as CookieConsent from "vanilla-cookieconsent";
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf.js';

pdfjsLib.GlobalWorkerOptions.workerSrc = document.querySelector('meta[name="pdfjs-worker-src"]')?.content
    || '/js/pdf.worker.min.js';

const dataTableLang = {
    "decimal":        ",",
    "emptyTable":     "Keine Datensätze gefunden",
    "info": "_MAX_ Datensätze",
    "infoEmpty": "-",
    "infoFiltered": "(gefiltert von _MAX_ Datensätzen)",
    "thousands":      ".",
    "lengthMenu": "_MENU_",
    "zeroRecords": "Keine Datensätze gefunden",
    "loadingRecords": "Lade",
    "searchPlaceholder": 'Suchen...',
    "processing": '<div class="loading-spinner text-center"><div class="spinner-grow mx-2 text-primary" role="status"></div><div class="spinner-grow mx-2 text-secondary" role="status"></div><div class="spinner-grow mx-2 text-grey" role="status"></div></div>'
};

document.addEventListener("DOMContentLoaded", function() {

    $('.fa-eye-slash').on('click', function() {
        $('#' + $(this).data('target')).attr({type: 'text'});
    })

    CookieConsent.run({
        cookie: {name: 'ccp_cookie'},
        guiOptions: {
            consentModal: {
                layout: 'cloud inline',
                position: 'bottom center',
                equalWeightButtons: true,
                flipButtons: false
            },
            preferencesModal: {
                layout: 'box',
                equalWeightButtons: true,
                flipButtons: false
            }
        },

        onFirstConsent: ({cookie}) => {},
        onConsent: ({cookie}) => {},
        onChange: ({changedCategories, changedServices}) => {},
        onModalReady: ({modalName}) => {},
        onModalShow: ({modalName}) => {},
        onModalHide: ({modalName}) => {},
        categories: {
            functional: {
                services: {
                    fonts: {
                        label: 'Adobe Fonts',
                        onAccept: () => {
                            $('head').append('<link id="typekit" rel="stylesheet" href="https://use.typekit.net/gfe7xko.css">');
                        },
                        onReject: () => {
                            $('#typekit').remove();
                        }
                    }
                }
            }
        },

        language: {
            default: 'de',
            translations: {
                de: {
                    consentModal: {
                        title: 'Wir benutzen Cookies',
                        description: '',
                        acceptAllBtn: 'Alles erlauben',
                        acceptNecessaryBtn: 'Alles ablehnen',
                        showPreferencesBtn: 'Individuelle Einstellungen',
                        footer: `
                        <a href="https://certifiedpremiumpellets.de/impressum-und-datenschutz/#impressum" target="_blank">Impressum</a>
                        <a href="https://certifiedpremiumpellets.de/impressum-und-datenschutz/#datenschutz" target="_blank">Datenschutz</a>
                    `,
                    },
                    preferencesModal: {
                        title: 'Datenschutzeinstellungen',
                        acceptAllBtn: 'Alles erlauben',
                        acceptNecessaryBtn: 'Nur essentielle',
                        savePreferencesBtn: 'Aktuelle Auswahl bestätigen',
                        closeIconLabel: 'Schliessen',
                        serviceCounterLabel: 'Service',
                        sections: [
                            {
                                title: 'Datenschutzeinstellungen',
                                description: 'Wir nutzen Adobe Fonts, um eine ansprechende und gut lesbare Schrift auf unserer Website zu gewährleisten. Dies verbessert die Benutzererfahrung und sorgt für ein einheitliches Design auf allen Geräten. Dabei werden keine Cookies gesetzt, jedoch können durch Adobe Fonts Verbindungsdaten übertragen werden. Mehr Infos in unserer Datenschutzerklärung',
                            },
                            {
                                title: 'Essenziell',
                                description: 'Erforderlich für die einwandfreie Funktion der Website',
                                linkedCategory: 'necessary'
                            },
                            {
                                title: '<p class="text-center">Funktional</p>',
                                linkedCategory: 'functional',
                            }
                        ]
                    }
                }
            }
        }
    });


    $('#notifications').on('click', function () {
        $('#notifications').html('')
    })

    /**
     * 21.02.25
    **/
    $('.link').on('click', function () {
        if ($(this).data('target')) {
            window.location.href = $(this).data('target');
        }
    })

    /**
     * REGISTRATION
     */
    if ($('.register-wrapper').length > 0) {
        $('input').on('keydown', function (e) {
            $(this).removeClass('error');
        })

        $('#password').on('blur', function () {
            let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,}$/;

            if (regex.test($("#password").val())) {
                $('#password').removeClass('error');
            } else {
                showNotifications([{type: 'danger', text: 'Passwort muss min. 8 Zeichen, Groß- & Kleinbuchstaben und ein Sonderzeichen enthalten'}])
                $('#password').addClass('error');
            }
        });

        $('.certificate-chooser').on('click', function () {
            if ($(this).find('.checkbox').hasClass('fa-square')) {
                $(this).find('.checkbox').removeClass('fa-square')
                $(this).find('.checkbox').addClass('fa-square-check')
            } else {
                $(this).find('.checkbox').addClass('fa-square')
                $(this).find('.checkbox').removeClass('fa-square-check')
            }
            let checkedCertificates = [];

            $.each($('.certificate-chooser'), function (k, cc) {
                if ($(this).find('.checkbox').hasClass('fa-square-check')) {
                    checkedCertificates.push({'id': $(cc).data('id')})
                }
            })
            if (checkedCertificates.length > 0) {
                $('#certificates').val(JSON.stringify(checkedCertificates));
            } else {
                $('#certificates').val('');
            }
        })

        $('#password-confirm').on('blur', function () {
            if ($('#password-confirm').val() !== $('#password').val()) {
                showNotifications([{type: 'danger', text: 'Die Passwörter stimmen nicht überein'}])
                $('#password-confirm').addClass('error');
                $('#password').addClass('error');
            }
        })

        $('.step-btn').on('click', function (e) {
            e.preventDefault();
            $('#register-alerts').html('');

            let currentStep = $(this).closest('.step');
            let error = false;
            $.each(currentStep.find('input, select, textarea'), function () {
                if ($(this).attr('required') !== undefined && $(this).val().length === 0) {
                    if ($(this).attr('id') === 'certificates') {
                        showNotifications([{type: 'danger', text: 'Wählen Sie mindestens ein Zertifikat aus.'}])
                    }
                    error = true;
                    $(this).addClass('error');
                } else {
                    $(this).removeClass('error');
                }
            })
            if (error === false) {
                if ($(this).hasClass('register-company')) {
                    let form = $('#register-form');
                    let formData = new FormData(form[0]);

                    axios.post('/register-company', formData).then(function (response) {
                            showResponse(response);
                            if (response.status === 200) {
                                location.href = '/registered';
                            }
                    }).catch(function (error) {
                        showResponse(error.response);
                    });
                } else {
                    currentStep.addClass('d-none');
                    $('#' + $(this).data('step-target')).removeClass('d-none');
                }
            }
        })
    }

    /**
     * DASHBOARD
     * 25.02.25
    **/
    if ($('#company-certificates-wrapper').length > 0) {
        loadCompanyCertificates()
    }

    if ($('.certifier-chooser').length > 0) {
        $('.certifier-chooser').on('click', function () {
            $('#process_certifier_id').val($(this).data('id'));

            $.each($('.certifier-chooser'), function (k, cc) {
                $(cc).removeClass('active');
            })

            $(this).addClass('active');
            $('#choose_certifier_id').val($(this).data('id'));
        })
    }

    if ($('#change-certifier-btn').length > 0) {
        $('#change-certifier-btn').on('click', function () {
            axios.post('/change-certifier', {
                'certificate_id': $('#certificate_id').val(),
                'certifier_id': $('#choose_certifier_id').val()
            }).then(function (response) {
                loadTimeline();
                showResponse(response);
                $('#change-certifier').modal('hide');
            }).catch(function (error) {
                console.error(error);
            });
        })
    }

    if ($('#renew-certificate').length > 0) {
        $('#renew-certificate-process').on('click', function () {
            axios.post('/renew-certificate-process', {
                'certificate_id': $('#certificate_id').val(),
                'certifier_id': $('#choose_certifier_id').val()
            }).then(function (response) {
                loadTimeline();
                showResponse(response);
                $('#renew-certificate').modal('hide');
            }).catch(function (error) {
                console.error(error)
            });
        })
    }

    if ($('#newCertificateProcessModal').length > 0) {
        $('#newCertificateProcessModal').on('show.bs.modal', function (e) {
            console.log($(e.relatedTarget).data('department_id'))
            $('#process_department_id').val($(e.relatedTarget).data('department_id'))
        })
        $('.department-chooser').on('click', function () {
            $.each($('.department-chooser'), function () {
                $(this).removeClass('active');
            });

            $(this).addClass('active');

            // $('#production_q1').val($(this).data('q1'));
            // $('#production_q2').val($(this).data('q2'));

            $('#process_department_id').val($(this).data('id'));
        })

        // $('#production_q1_check').on('change', function() {
        //     if ($(this).is(':checked')) {
        //         $('#production_q1_wrapper').removeClass('d-none');
        //     } else {
        //         $('#production_q1_wrapper').addClass('d-none');
        //     }
        // })
        // $('#production_q2_check').on('change', function() {
        //     if ($(this).is(':checked')) {
        //         $('#production_q2_wrapper').removeClass('d-none');
        //     } else {
        //         $('#production_q2_wrapper').addClass('d-none');
        //     }
        // })



        // $('#process_certificate_api_key').on('keyup', function () {
        //     if ($(this).val().length > 0) {
        //         $('#create-certificate-process').removeClass('d-none');
        //     } else {
        //        $('#create-certificate-process').addClass('d-none');
        //     }
        // })
        $('#create-certificate-process').on('click', function () {
            axios.post('/create-certificate-process', {
                'company_id': $('#process_company_id').val(),
                'department_id': $('#process_department_id').val(),
                // 'production_q1_check': $('#production_q1_check').is(':checked') ? 1 : 0,
                // 'production_q1': $('#process_production_q1').val(),
                // 'production_q2_check': $('#production_q2_check').is(':checked') ? 1 : 0,
                // 'production_q2': $('#process_production_q2').val(),
                'certifier_id': $('#process_certifier_id').val()
                // 'provider_id': $('#process_certificate_api_key').val()
            }).then(function (response) {
                loadCompanyCertificates();
                showResponse(response, $('#newCertificateProcessModal'));
            }).catch(function (error) {
                console.error(error)
            });
        })
    }

    (g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
        key: "AIzaSyBzWcEGQHzndMa3DxvDVOro0NQnQR5f3ZA",
        v: "weekly",
        language: "de",
        region: "DE"
    });

    let geocoderPromise;

    async function getGeocoder() {
        if (!geocoderPromise) {
            geocoderPromise = google.maps.importLibrary("geocoding").then(({ Geocoder }) => {
                return new Geocoder();
            });
        }
        return geocoderPromise;
    }

    async function geocodeAddress({ street = "", zip = "", city = "", country = "DE" }) {
        const geocoder = await getGeocoder();
        const address = [street, zip, city, country].filter(Boolean).join(", ");

        const response = await geocoder.geocode({
            address,
            componentRestrictions: {
                country
            }
        });

        if (!response.results || !response.results.length) {
            return null;
        }

        const result = response.results[0];
        const location = result.geometry.location;

        return {
            lat: location.lat(),
            lng: location.lng(),
            formatted_address: result.formatted_address,
            place_id: result.place_id,
            partial_match: !!result.partial_match
        };
    }

    function setLatLon () {
        if (
            $('#department_street').val().length > 0 &&
            $('#department_zip_code').val().length > 0 &&
            $('#department_city').val().length > 0 &&
            $('#department_country').val().length > 0
        ) {
            geocodeAddress({
                street: $('#department_street').val(),
                zip: $('#department_zip_code').val(),
                city: $('#department_city').val(),
                country: $('#department_country').val()
            })
                .then((data) => {
                    $('#latitude').val(data.lat);
                    $('#longitude').val(data.lng);
                })
                .catch((err) => {
                    console.error(err);
                });
        }
    }

    /**
     * DEPARTMENTS
     */
    if ($('#departmentsTable').length > 0) {
        let departmentsTable = $('#departmentsTable').dataTable({
            dom: 't',
            lengthMenu: [[-1], ['Alle']],
            processing: true,
            serverSide: true,
            autoWidth: false,
            ajax: {
                url: '/get-departments',
                data: {'company_id': $('#departmentsTable').data('company-id')},
                type: 'GET'
            },
            columns: [
                {
                    className: 'dt-main-col',
                    data: 'department_name',
                    name: 'department_name',
                    sortable: false,
                    searchable: false
                },
                {
                    className: 'dt-show-more',
                    orderable: false,
                    data: null,
                    defaultContent: '<i class="fa-solid fa-chevron-down"></i>',
                    targets: 1, width: 1
                },
                { data: 'action', name: 'action', targets: 1, width: 1, sortable: false }
            ],
            language: dataTableLang
        });



        $('#new-department').on('click', function () {
            $('#department_id').val('');
            $('#departmentModal').modal('show');
        })


        /**
         * 20.02.25
         * Listener for "ändern" Button
         **/
        departmentsTable.on('click', '.edit-department', function (e) {
            $('#departmentModal').modal('show');
            axios.get('/get-department', {
                params: {
                    department_id: $(this).data('id')
                },
            }).then(function (response) {
                $('#department_id').val(response.data.id);
                $('#company_id').val(response.data.company_id);
                $('#department_name').val(response.data.department_name);
                $('#sure_api_key').val(response.data.sure_api_key);
                $('#department_city').val(response.data.department_city);
                $('#department_zip_code').val(response.data.department_zip_code);
                $('#department_street').val(response.data.department_street);
                $('#department_street_2').val(response.data.department_street_2);
                $('#department_country').val(response.data.department_country);
                $('#department_email').val(response.data.department_email);
                $('#department_phone').val(response.data.department_phone);
                $('#latitude').val(response.data.latitude);
                $('#longitude').val(response.data.longitude);


                if (response.data.longitude === null && response.data.longitude === null) {
                    setLatLon();
                }

            }).catch(function (error) {
                console.error(error);
            });
        })

        /**
         * 20.02.25
         **/
        if ($('#departmentModal').length > 0) {
            $('#departmentModal').on('show.bs.modal', function () {
                $('#department-form')[0].reset();
            })

            $('#save-department').on('click', function (e) {
                e.preventDefault();
                $('#department-alerts').html('');
                axios.post('/save-department', {
                    'department_id': $('#department_id').val(),
                    'company_id': $('#id').val(),
                    'department_name': $('#department_name').val(),
                    'sure_api_key': $('#sure_api_key').val(),
                    'department_city': $('#department_city').val(),
                    'department_zip_code': $('#department_zip_code').val(),
                    'department_street': $('#department_street').val(),
                    'department_street_2': $('#department_street_2').val(),
                    'latitude': $('#latitude').val(),
                    'longitude': $('#longitude').val(),
                    'department_country': $('#department_country').val(),
                    'department_phone': $('#department_phone').val(),
                    'department_email': $('#department_email').val(),
                }).then(function (response) {
                    departmentsTable.api().draw();
                    showResponse(response, $('#departmentModal'));
                }).catch(function (error) {
                    console.error(error)
                });
            });

            $('#delete-department').on('click', function (e) {
                e.preventDefault();
                $('#department-alerts').html('');
                axios.delete('/delete-department', { data:
                    {
                        'department_id': $('#department_id').val()
                    }
            }).then(function (response) {
                    departmentsTable.api().draw();
                    $('#departmentModal').modal('hide');
                    showResponse(response, $('#notifications'));
                }).catch(function (error) {
                    console.error(error)
                });
            });

            $('#department-form').on('change', '#department_street, #department_zip_code, #department_city, #department_country', async function () {
                setLatLon();
            });
        }

        /**
         * Add event listener for opening and closing details
         * 20.02.25
         **/
        departmentsTable.on('click', 'td.dt-show-more', function (e) {
            let tr = e.target.closest('tr');
            let row = departmentsTable.api().row(tr);

            if (row.child.isShown()) {
                $(this).parent().find('.dt-main-col').removeClass('bold');
                $(this).find('i').removeClass('fa-chevron-up').addClass('fa-chevron-down');
                row.child.hide();
            }
            else {
                $(this).parent().find('.dt-main-col').addClass('bold');
                $(this).find('i').removeClass('fa-chevron-down').addClass('fa-chevron-up');
                row.child(formatDepartmentRow(row.data())).show();
            }
        });

        /**
         * Formatter for sub-row
         * 20.02.25
         **/
        function formatDepartmentRow(d) {
            let result = '<dl class="text-left">';
            if (d.department_street !== null) { result += '<dd>' + d.department_street + '</dd>';}
            if (d.department_street_2 !== null) { result += '<dd>' + d.department_street_2 + '</dd>';}

            if (d.department_city !== null || d.department_zip_code !== null) {
                result += '<dd>' + d.department_city + ' ' + d.department_zip_code + '</dd>';
            }

            if (d.production_q1 !== null) { result += '<dd><strong>Q1:</strong> ' + d.production_q1 + '</dd>';}
            // if (d.production_q2 !== null) { result += '<dd><strong>Q2:</strong> ' + d.production_q2 + '</dd>';}

            result += '</dl>';

            return (result);
        }
    }


    /**
     * Users DataTable
     * 20.02.25
    **/
    if ($('#users-table').length > 0) {
        let usersTable = $('#users-table').dataTable({
            dom: 't',
            lengthMenu: [[-1], ['Alle']],
            processing: true,
            serverSide: true,
            autoWidth: false,
            ajax: {
                url: '/load-users',
                data: {'company_id': $('#users-table').data('company-id')},
                type: 'GET'
            },
            columns: [
                { data: 'name', name: 'name', className: 'dt-main-col', sortable: false, searchable: false },
                { data: 'departments', name: 'departments', sortable: false, searchable: false },
                {
                    className: 'dt-show-more',
                    orderable: false,
                    data: null,
                    defaultContent: '<i class="fa-solid fa-chevron-down"></i>',
                    targets: 1, width: 1
                },
                { data: 'action', name: 'action', targets: 1, width: 1, sortable: false }
            ],
            language: dataTableLang
        });

        /**
         * 20.02.25
         * Listener for "ändern" Button
         **/
        usersTable.on('click', '.edit-user', function (e) {
            $('#user-form')[0].reset();
            $('#user_company_id').val($('#id').val());
            $('#department-list').html('');
            $('#userModal').modal('show');
            axios.get('/get-user', {
                params: {
                    user_id: $(this).data('id')
                },
            }).then(function (response) {
                $('#user_id').val(response.data.id);
                $('#user_title').val(response.data.title);
                $('#user_first_name').val(response.data.first_name);
                $('#user_name').val(response.data.name);
                $('#user_email').val(response.data.email);
                $('#user_phone').val(response.data.phone);
                $('#user_activity').val(response.data.activity);
                $('#user_sure_id').val(response.data.sure_id);

                if (response.data.active === 1) {
                    $('#user_active').attr({'checked': 'checked'})
                }
                if (response.data.distributor_certifier === 1) {
                    $('#distributor_certifier').attr({'checked': 'checked'})
                } else {
                    $('#distributor_certifier').removeAttr('checked')
                }
                if (response.data.admin === 1) {
                    $('#admin').attr({'checked': 'checked'})
                } else {
                    $('#admin').removeAttr('checked')
                }

                $('#department-list').html(response.data.departments);

                if (response.data.otherUsersInCompany > 1) {
                    $('#delete-user').removeClass('d-none');
                } else {
                    $('#delete-user').addClass('d-none');
                }

                if (response.data.current_user) {
                    $('#password-tab').parent().removeClass('d-none');
                    $('.old-user').removeClass('d-none');
                    $('#password').removeClass('d-none');
                    $('#2fa').removeClass('d-none');
                    $('.new_user').addClass('d-none');
                    if (response.data.two_factor_secret === null) {
                        $('#qr-code-wrapper').html('')
                        $('#2fa-disable-tab').addClass('d-none');
                        $('#2fa-enable-tab').removeClass('d-none');
                    } else {
                        $('#qr-code-wrapper').html(response.data.qr)
                        for (let recovery_code in response.data.recovery_codes) {
                            $('#recovery-codes-wrapper').append('<li style="list-style: none;">' + response.data.recovery_codes[recovery_code] + '</li>')
                        }
                        $('#2fa-disable-tab').removeClass('d-none');
                        $('#2fa-enable-tab').addClass('d-none');
                    }
                } else {
                    $('#password-tab').addClass('d-none');
                    $('#2fa-tab').parent().addClass('d-none');
                    $('#password').addClass('d-none');
                    $('#2fa').addClass('d-none');
                }
            }).catch(function (error) {
                console.error(error);
            });
        })


        if ($('#delete-user').length > 0) {
            $('#delete-user').on('click', function () {
                $('#confirmed-delete').data({id: $('#user_id').val(), type: 'user'});
                $('#deleteConfirmModal').modal('show');

            })

        }

        if ($('#confirmed-delete').length > 0) {
            $('#confirmed-delete').on('click', function () {
                $('#deleteConfirmModal').modal('hide');
                axios
                    .delete('/delete-' + $(this).data('type'), { data: {'id': $(this).data('id')}})
                    .then(function (response) {
                        showResponse(response, $('#notifications'));
                        $('#userModal').modal('hide');
                        usersTable.api().draw();
                    })
                    .catch(function (error) {
                        showResponse(error, $('#notifications'));
                    });
            })
        }


        /**
         * Add event listener for opening and closing details
         * 20.02.25
         **/
        usersTable.on('click', 'td.dt-show-more', function (e) {
            let tr = e.target.closest('tr');
            let row = usersTable.api().row(tr);

            if (row.child.isShown()) {
                $(this).parent().find('.dt-main-col').removeClass('bold');
                $(this).find('i').removeClass('fa-chevron-up').addClass('fa-chevron-down');
                row.child.hide();
            }
            else {
                $(this).parent().find('.dt-main-col').addClass('bold');
                $(this).find('i').removeClass('fa-chevron-down').addClass('fa-chevron-up');
                row.child(formatUserRow(row.data())).show();
            }
        });

        /**
         * Formatter for sub-row
         * 20.02.25
         **/
        function formatUserRow(d) {
            let result = '<dl class="text-left">';
            if (d.email !== null) { result += '<dd>' + d.email + '</dd>';}
            if (d.phone !== null) { result += '<dd>' + d.phone + '</dd>';}

            return (result);
        }

        /**
         * 20.02.25
         **/
        if ($('#userModal').length > 0) {
            $('#new-user').on('click', function (e) {
                $('#delete-user').addClass('d-none');
                $('#user-form')[0].reset();
                $('#user_company_id').val($('#id').val());
                $('#user_id').val('');

                $('#department-list').html('');

                axios.get('/get-user-departments-as-list', {
                    params: {
                        'company_id': $('#id').val(),
                        'user_id': null,
                    }
                }).then(function (response) {
                    if (response.data.html !== undefined) {
                        $('#department-list').html(response.data.html);
                    }
                }).catch(function (error) {
                    console.error(error)
                });

                $('#userModal').modal('show');

                $('.new_user').removeClass('d-none');
                $('#password-tab').addClass('d-none');
                $('#2fa-tab').addClass('d-none');
                $('#password').addClass('d-none');
                $('#2fa').addClass('d-none');


                // $('.new_user').removeClass('d-none');
                // $('.old_user').addClass('d-none');
            })

            $('#save-user').on('click', function (e) {
                e.preventDefault();
                $('#user-alerts').html('');

                let form = $('#user-form');
                let formData = new FormData(form[0]);

                axios.post('/save-user', formData).then(function (response) {
                    usersTable.api().draw();
                    $('#userModal').modal('hide');
                    showResponse(response);
                }).catch(function (error) {
                    showResponse(error.response, $('#userModal'));
                });
            });
        }

        $('.confirm-password-change').on('click', function (e) {
            $('#user-modal-alerts').html('');
            e.preventDefault();
            axios.post('/change-password', {
                'user_id': $('#user_id').val(),
                'old_password': $('#old_password').val(),
                'new_password': $('#new_password').val(),
                'new_password_confirmation': $('#new_password_confirmation').val()
            }).then(function (response) {
                if (response.data.message !== undefined) {
                    $('#user-modal-alerts').append('<div class="alert alert-info" role="alert">' + response.data.message + '</div>')
                }
            }).catch(function (error) {
                let message = error.response.data.message;

                $.each(error.response.data.errors, function (errKey, errVals) {
                    $.each(errVals, function (errKey, errVal) {
                        message += errVal
                    });
                })

                $('#user-modal-alerts').append('<div class="alert alert-danger" role="alert">' + message + '</div>')
            }).finally(function () {
                // $('#change-password-modal').modal('hide')
            });
        })

        $('#activate-2fa').on('click', function (e) {
            e.preventDefault();
            axios.post('/user/two-factor-authentication').then(function (response) {
                axios.get('/user/get-two-factor-authentication').then(function (response) {
                    $('#enable-modal-wrapper').html('<div>' + response.data.qr + '</div><p><h5>Wiederherstellungscodes</h5></p><ul>');
                    $.each(response.data.codes, function (k, code) {
                        $('#enable-modal-wrapper').append('<li style="list-style: none;">' + code + '</li>');
                    })
                    $('#enable-modal-wrapper').append('</ul>');
                    $('#activate-2fa').hide();
                }).catch(function (error) {
                    console.log(error);
                })
            }).catch(function (error) {
                console.log(error);
            });
        })

        $('#deactivate-2fa').on('click', function (e) {
            e.preventDefault();
            let form = $('#deactivate-2fa-form');
            let formData = new FormData(form[0]);

            axios.post('/user/two-factor-authentication', formData).then(function (response) {
                if (response.status === 200) {
                    $('#2fa-disable-tab').addClass('d-none');
                    $('#2fa-enable-tab').removeClass('d-none');
                }
            }).catch(function (error) {
                console.log(error);
            });
        })
    }

    /**
     * COMPANIES
     */
    if ($('#companiesTable').length > 0) {
        let data = function (d) {
            d.filter_search = $('#filter-search').val();
        };

        let companiesTable = $('#companiesTable').dataTable({
            processing: true,
            serverSide: true,
            ajax: {
                url: '/load-companies',
                data: data,
                type: 'GET'
            },
            columns: [
                {
                    className: 'dt-main-col',
                    data: 'company_name',
                    name: 'company_name',
                    searchable: false
                },
                { data: 'company_identification', name: 'company_identification'},
                { data: 'company_type', name: 'company_type'},
                { data: 'active', name: 'active'},
                {
                    className: 'dt-show-more min-width-column',
                    data: null,
                    defaultContent: '<i class="fa-solid fa-chevron-down"></i>',
                    targets: 1, width: 1, sortable: false, searchable: false
                },
                { data: 'action', name: 'action', className: 'min-width-column', sortable: false, searchable: false }
            ],
            dom: 't<"dt-bottom d-flex justify-content-between"lip>',
            language: dataTableLang
        });

        $('#filter-search').on('keyup', function () {
            companiesTable.api().draw();
        })


        /**
         * Add event listener for opening and closing details
         * 03.03.25
         **/
        companiesTable.on('click', 'td.dt-show-more', function (e) {
            let tr = e.target.closest('tr');
            let row = companiesTable.api().row(tr);

            if (row.child.isShown()) {
                $(this).parent().find('.dt-main-col').removeClass('bold');
                $(this).find('i').removeClass('fa-chevron-up').addClass('fa-chevron-down');
                row.child.hide();
            }
            else {
                $(this).parent().find('.dt-main-col').addClass('bold');
                $(this).find('i').removeClass('fa-chevron-down').addClass('fa-chevron-up');
                row.child(formatCompanyRow(row.data())).show();
            }
        }).on('click', '.delete-company', function (e) {
            let tr = e.target.closest('tr');
            let row = companiesTable.api().row(tr).data();

            $('#delete-company-name').text(row.company_name)
            $('#delete_company_id').val(row.company_id)
            $('#delete-company-modal').modal('show');
        }).on('click', '.active-company', function (e) {
            let tr = e.target.closest('tr');
            let row = companiesTable.api().row(tr).data();

            if (row.active_value === 1) {
                $('#activate-company').addClass('d-none');
                $('#deactivate-company').removeClass('d-none');
            } else {
                $('#deactivate-company').addClass('d-none');
                $('#activate-company').removeClass('d-none');
            }

            $('#delete-company-name').text(row.company_name)
            $('#active_company_id').val(row.company_id)

            $('#active_state').val(row.active_value)
            $('#active-company-modal').modal('show');
        })

        /**
         * Formatter for sub-row
         * 20.02.25
         **/
        function formatCompanyRow(d) {
            let result = '<dl class="text-left">';
            result += '</dl>';
            return d.departments;
        }

        if ($('#delete-company-modal').length > 0) {
            $('#confirm-company-delete').on('click', function () {
                axios
                    .delete('/delete-company', { data: {'company_id': $('#delete_company_id').val()}})
                    .then(function (response) {
                        showResponse(response, $('#delete-company-modal'));
                        companiesTable.api().draw();
                    })
                    .catch(function (error) {
                        showResponse(error, $('#delete-company-modal'));
                    });
            })
        }

        if ($('#active-company-modal').length > 0) {
            $('#confirm-company-active').on('click', function () {
                axios
                    .post('/active-company',{
                        'company_id': $('#active_company_id').val()})
                    .then(function (response) {
                        showResponse(response, $('#active-company-modal'));
                    })
                    .catch(function (error) {
                        showResponse(error, $('#active-company-modal'));
                    });
            })

            $('#active-company-modal').on('hide.bs.modal', function () {
                companiesTable.api().draw();
            });
        }
    }

    if ($('#update-company-btn').length > 0) {
        $('#update-company-btn').on('click', function() {
            var formData = new FormData();
            var logoFile = document.querySelector('#logo_upload');
            formData.append("logo", logoFile.files[0]);
            formData.append("company_id", $('#id').val());
            formData.append("company_name", $('#company_name').val());
            formData.append("company_country", $('#company_country_code').val());
            formData.append("company_identification", $('#company_identification').val());
            formData.append("sure_api_key", $('#sure_api_key').val());
            formData.append("company_web", $('#company_web').val());
            axios.post('/update-company', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {
                showResponse(response, $('#companyModal'));
                if (response.data.status !== undefined && response.data.status === 'Erfolgreich gespeichert') {
                    location.reload();
                }

            }).catch(function (error) {
                console.log(error, $('#companyModal'));
            });
        })
    }
    if ($('#add-bag-layout').length > 0) {


        loadBagLayouts();

        // Create hidden file input for bag layout upload
        if ($('#bag_layout_upload').length === 0) {
            $('body').append('<input type="file" id="bag_layout_upload" accept="image/*,application/pdf" class="d-none">');
        }

        $('#add-bag-layout').on('click', function () {
            $('#bag_layout_upload').click();
        });

        $('#bag_layout_upload').on('change', function () {
            if (this.files && this.files[0]) {
                uploadBagLayout(this.files[0]);
            }
        });

        $('#confirmed-bag-layout-delete').on('click', function () {
            axios.delete('/delete-bag-layout', {
                data: {
                        "bag_layout_id": $('#delete-bag-layout-id').text()
                }
            }).then(function (response) {
                location.reload();
            }).catch(function (error) {
                console.error(error);
            })
        })


        function loadBagLayouts() {
            axios.get('/load-bag-layouts', {params: {company_id: $('#id').val()}
            }).then(function (response) {
                $('#bag-container').html(response.data.html);

                $('.update-bag-layout-btn').on('click', function() {
                    let layoutId = $(this).data('id')

                    axios.post('/update-bag-layout', {
                        "bag_layout_id": layoutId,
                        "release_number": $('.release_number[data-id="' + layoutId + '"]').val(),
                        "product_name": $('.product_name[data-id="' + layoutId + '"]').val(),
                        "active": $('.layout-active[data-id="' + layoutId + '"]').is(':checked') ? 1 : 0
                    }).then(function (response) {
                        location.reload();
                    }).catch(function (error) {
                        console.error(error);
                    })
                });

                $('.delete-bag-layout-btn').on('click', function() {
                    let layoutId = $(this).data('id');

                    $('#delete-bag-layout-modal').modal('show');
                    $('#delete-bag-layout-id').text(layoutId);
                });
            }).catch(function (error) {
                console.error(error);
            });
        }

        async function convertPdfToWebp(file) {
            const pdf = await pdfjsLib.getDocument({
                data: new Uint8Array(await file.arrayBuffer())
            }).promise;
            const canvas = document.createElement('canvas');
            let page;

            try {
                page = await pdf.getPage(1);
                const viewport = page.getViewport({scale: 150 / 72});
                canvas.width = Math.ceil(viewport.width);
                canvas.height = Math.ceil(viewport.height);

                const context = canvas.getContext('2d', {alpha: false});
                if (!context) {
                    throw new Error('Der PDF-Renderer konnte nicht gestartet werden.');
                }

                context.fillStyle = '#ffffff';
                context.fillRect(0, 0, canvas.width, canvas.height);
                await page.render({canvasContext: context, viewport}).promise;

                const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/webp', 0.92));
                if (!blob || blob.type !== 'image/webp') {
                    throw new Error('Dieser Browser kann keine WebP-Vorschau erstellen.');
                }

                const name = file.name.replace(/\.pdf$/i, '') + '.webp';
                return new File([blob], name, {type: 'image/webp', lastModified: Date.now()});
            } finally {
                if (page) {
                    page.cleanup();
                }
                await pdf.destroy();
                canvas.width = 0;
                canvas.height = 0;
            }
        }

        async function uploadBagLayout(file) {
            if (file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')) {
                try {
                    file = await convertPdfToWebp(file);
                } catch (error) {
                    showResponse({data: {error: [error.message || 'Das PDF konnte nicht in eine WebP-Vorschau umgewandelt werden.']}});
                    return;
                }
            }

            var formData = new FormData();
            formData.append("bag_layout", file);
            formData.append("company_id", $('#id').val());

            axios.post('/upload-bag-layout', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {
                showResponse(response);
                loadBagLayouts();

            }).catch(function (error) {
                showResponse(error.response || {data: {error: ['Das Layout konnte leider nicht hochgeladen werden.']}});
            });
        }
    }


    if ($('#timeline-wrapper').length > 0) {
        loadTimeline();
    }

    if ($('#department-certificate-wrapper').length > 0) {
        loadDepartmentCertificates($('#department_id').val())
    }

    /**
     * CERTIFICATES
     */
    if ($('#certificatesTable').length > 0) {
        let certificateDateTable = $('#certificatesTable').dataTable({
            processing: true,
            serverSide: true,
            ajax: {
                url: '/load-certificates',
                data: function (d) {
                    d.filter_search = $('#filter-search').val();
                },
                type: 'GET'
            },
            columns: [
                { data: 'id', name: 'id', visible: false, searchable: false },
                { className: 'dt-main-col', data: 'certificate_name', name: 'certificate_name', searchable: false },
                { data: 'certificate_provider', name: 'certificate_provider', searchable: false },
                { data: 'action', name: 'action', className: 'min-width-column', sortable: false, searchable: false }
            ],
            dom: 't<"dt-bottom d-flex justify-content-between"lip>',
            language: dataTableLang
        });

        $('#filter-search').on('keyup', function () {
            certificateDateTable.api().draw();
        })

        $('#save-certificate').on('click', function (e) {
            e.preventDefault();
            $('#certificate-alerts').html('');
            axios.post('/save-certificate', {
                'certificate_id': $('#certificate_id').val(),
                'certificate_name': $('#certificate_name').val(),
                'certificate_provider': $('#certificate_provider').val(),
                'certificate_api_key': $('#certificate_api_key').val()
            }).then(function (response) {
                showAjaxAlert($('#certificate-alerts'), response);
            }).catch(function (error) {
                $('#certificate-alerts').append('<div class="alert alert-danger" role="alert">Der Datensatz konnte leider nicht gespeichert werden</div>')
            });
        });

        let certificateModal = $('#certificateModal');

        $('#delete-certificate').on('click', function (e) {
            e.preventDefault();
            $('#alerts').html('');
            axios.delete('/delete-certificate', { data: {'certificate_id': $('#certificate_id').val()}

            }).then(function (response) {
                certificateModal.modal('hide')
                showAjaxAlert($('#alerts'), response);
            }).catch(function () {
                $('#alerts').append('<div class="alert alert-danger" role="alert">Der Datensatz konnte leider nicht gelöscht werden</div>')
                // certificateModal.hide();
            });

        });

        certificateDateTable.on('click', 'tbody tr', function (v) {
            let rowData = certificateDateTable.api().row(this).data();
            if (rowData) {
                $('#certificate_id').val(rowData.id);
                $('#certificate_name').val(rowData.certificate_name);
                $('#certificate_provider').val(rowData.certificate_provider);
                $('#certificate_api_key').val(rowData.certificate_api_key);
            }
        });

        certificateModal.addEventListener('hide.bs.modal', event => {
            certificateDateTable.api().draw();
        })
    }

    /**
     * 28.02.25
    **/
    if ($('#relevant-certificates').length > 0) {
        let data = function (d) {
            d.filter_search = $('#filter-search').val();
            d.filter_state = $('#filter-state').val();
            d.filter_type = $('#relevant-certificates').data('type');
        };

        let companiesForCertifierDataTable = $('#relevant-certificates').dataTable({
            dom: 't<"dt-bottom d-flex justify-content-between"lip>',
            processing: true,
            serverSide: true,
            ajax: {
                url: '/load-relevant-certificates',
                data: data,
                type: 'GET'
            },
            columns: [
                { data: 'company_name', name: 'company_name' },
                { data: 'department_name', name: 'company_departments.department_name' },
                { data: 'company_identification', name: 'company_identification' },
                { data: 'certifier', name: 'certifier' },
                { data: 'my_state', name: 'my_state' },
                { data: 'certifier_state', name: 'certifier_state' },
                { data: 'provider_state', name: 'provider_state' },
                { data: 'action', name: 'action', searchable: false, sortable: false },
            ],
            language: dataTableLang
        });

        $('#filter-search').on('keyup', function () {
            companiesForCertifierDataTable.api().draw();
        })
    }

    /**
     * 28.02.25
    **/
    if ($('#relevant-distributor-certificates').length > 0) {
        let data = function (d) {
            d.filter_search = $('#filter-search').val();
            d.filter_state = $('#filter-state').val();
            d.filter_type = 'distributor';
        };

        let distributorForCertifierDataTable = $('#relevant-distributor-certificates').dataTable({
            dom: 't<"dt-bottom d-flex justify-content-between"lip>',
            processing: true,
            serverSide: true,
            ajax: {
                url: '/load-relevant-certificates',
                data: data,
                type: 'GET'
            },
            columns: [
                { data: 'company_name', name: 'company_name' },
                { data: 'department_name', name: 'company_departments.department_name' },
                { data: 'company_identification', name: 'company_identification' },
                { data: 'certifier', name: 'certifier' },
                { data: 'my_state', name: 'my_state' },
                { data: 'action', name: 'action', searchable: false, sortable: false },
            ],
            language: dataTableLang
        });

        $('#filter-search').on('keyup', function () {
            distributorForCertifierDataTable.api().draw();
        })
    }

    /**
     * 28.02.25
    **/
    if ($('#relevant-certifier-certificates').length > 0) {
        let data = function (d) {
            d.filter_search = $('#filter-search').val();
            d.filter_state = $('#filter-state').val();
        };

        let companiesForCertifierDataTable = $('#relevant-certifier-certificates').dataTable({
            dom: 't<"dt-bottom d-flex justify-content-between"lip>',
            processing: true,
            serverSide: true,
            ajax: {
                url: '/load-relevant-certificates',
                data: data,
                type: 'GET'
            },
            columns: [
                { data: 'company_name', name: 'companies.company_name' },
                { data: 'department_name', name: 'company_departments.department_name' },
                { data: 'company_identification', name: 'company_identification' },
                { data: 'my_state', name: 'my_state' },
                // { data: 'certifier_state', name: 'certifier_state' },
                // { data: 'provider_state', name: 'provider_state' },
                { data: 'action', name: 'action', searchable: false, sortable: false },
            ],
            language: dataTableLang
        });

        $('#filter-search').on('keyup', function () {
            companiesForCertifierDataTable.api().draw();
        })
    }
    /**
     * 28.02.25
    **/
    if ($('#relevant-distributor-certifier-certificates').length > 0) {
        let data = function (d) {
            d.filter_search = $('#filter-search').val();
            d.filter_state = $('#filter-state').val();
        };

        let companiesForDistributorCertifierDataTable = $('#relevant-distributor-certifier-certificates').dataTable({
            dom: 't<"dt-bottom d-flex justify-content-between"lip>',
            processing: true,
            serverSide: true,
            ajax: {
                url: '/load-relevant-certificates',
                data: data,
                type: 'GET'
            },
            columns: [
                { data: 'company_name', name: 'companies.company_name' },
                { data: 'department_name', name: 'company_departments.department_name' },
                { data: 'company_identification', name: 'company_identification' },
                { data: 'my_state', name: 'my_state' },
                // { data: 'certifier_state', name: 'certifier_state' },
                // { data: 'provider_state', name: 'provider_state' },
                { data: 'action', name: 'action', searchable: false, sortable: false },
            ],
            language: dataTableLang
        });

        $('#filter-search').on('keyup', function () {
            companiesForDistributorCertifierDataTable.api().draw();
        })
    }

    /**
     * 28.02.25
    **/
    if ($('#newCertificateStateModal').length > 0) {
        $('#create-certificate-state').on('click', function (e) {
            e.preventDefault();
            $('#state-alerts').html('');
            var formData = new FormData();
            var stateUpload = document.querySelector('#state_upload');
            if (stateUpload) {
                formData.append("state_upload", stateUpload.files[0]);
            }

            formData.append("state_id", $('#state_id').val());
            formData.append("department_certificate_id", $('#state_certificate_id').val());
            formData.append("user_id", $('#state_user_id').val());
            formData.append("state", $('#state_state').val());
            if ($('#state_note').length > 0) {
                formData.append("note", $('#state_note').val());
            }
            if ($('#remote_check').length > 0) {
                formData.append("remote_check", $('#remote_check').is(':checked') ? 1 : 0);
            }
            formData.append("state_valid", $('#state_valid').val());

            axios.post('/save-certificate-state', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {
                loadTimeline();
                showResponse(response, $('#newCertificateStateModal'));
            }).catch(function (error) {
                showResponse(error, $('#newCertificateStateModal'))
                // $('#state-alerts').append('<div class="alert alert-danger" role="alert">Der Datensatz konnte leider nicht gespeichert werden</div>')
            });
        })
    }

    if ($('.toggle-show-on-website').length > 0) {
        $('.toggle-show-on-website').on('click', function () {
            axios.post('/show-certificate-on-website', {
                'id': $('#certificate_id').val(),
            }).then(function (response) {
                if (response.status === 200) {
                    location.reload();
                } else {
                    showResponse(response);
                }
            }).catch(function (error) {
                showResponse(error);
            });
        })
    }

    if ($('#pending-registration-table').length > 0) {
        let pendingRegistrationTable = $('#pending-registration-table').dataTable({
            dom: 't',
            lengthMenu: [[-1], ['Alle']],
            processing: true,
            serverSide: true,
            ajax: {
                url: '/load-pending-registrations',
                type: 'GET'
            },
            columns: [
                { data: 'title', name: 'title' },
                { data: 'first_name', name: 'first_name' },
                { data: 'name', name: 'name' },
                { data: 'company_name', name: 'company_name' },
                { data: 'departments', name: 'departments' },
                // { data: 'state', name: 'state' },
                { data: 'action', name: 'action', searchable: false, sortable: false },
            ],
            language: dataTableLang
        });

        pendingRegistrationTable.on('click', 'tbody tr', function (e) {
            if ($(e.target).hasClass('show-pending-registration-details')) {
                let rowData = pendingRegistrationTable.api().row(this).data();
                if (rowData) {
                    axios.get('/load-pending-registration-details', {
                        params: {
                            user_id: rowData.user_id
                        },
                    }).then(function (response) {
                        $('#pendingRegistrationModal .modal-body').html(response.data.html);
                        $('#pendingRegistrationModal').modal('show');

                    }).catch(function (error) {
                        console.error(error);
                    });
                }
            }
        })

        if ($('#pendingRegistrationModal').length > 0) {
            $('#allow-user').on('click', function () {
                axios.post('/allow-user', {
                    'user_id': $('#pending_user_id').val()
                }).then(function (response) {
                    pendingRegistrationTable.api().draw();
                    showResponse(response, $('#pendingRegistrationModal'));
                }).catch(function (error) {
                    showResponse(error, $('#pendingRegistrationModal'));
                });
            })

            $('#deny-user').on('click', function () {
                axios.post('/deny-user', {
                    'user_id': $('#pending_user_id').val()
                }).then(function (response) {
                    pendingRegistrationTable.api().draw();
                    showResponse(response, $('#pendingRegistrationModal'));
                }).catch(function (error) {
                    showResponse(error, $('#pendingRegistrationModal'));
                });
            })
        }
    }

});

/**
 *
 * @param e
 */
let saveUser = function(e) {
    e.preventDefault();

    $(e.target).closest('.user-alerts').html('');

    let form = $(e.target).closest('form');
    form.find('.user-alerts').html('');
    let formData = new FormData(form[0]);

    axios.post('/save-user', formData).then(function (response) {
        if (response.status !== undefined && response.status === 200 && response.data.html !== undefined && response.data.status !== undefined) {
            $('#users-wrapper').html(response.data.html);
            form.find('.user-alerts').append('<div class="alert alert-info" role="alert">' + response.data.status + '</div>')

            $('.save-user-form').on('click', function (e) {
                saveUser(e);
            });
            $('#new-user').on('click', function () {
                $('.new-user-form').removeClass('d-none');
            });
        }
    }).catch(function (error) {
        $.each(error.response.data.errors, function (errKey, errVals) {
            $.each(errVals, function (errKey, errVal) {
                form.find('.user-alerts').append('<div class="alert alert-danger" role="alert">' + errVal + '</div>')
            });
        })
    });
}

/**
 *
 * @param response
 * @param target
 */
let showResponse = function (response, target) {
    let msg = [];


    if (target === undefined) {
        target = $("#notifications");
    }



    if (response.data !== undefined && response.data.message !== undefined) {
        if (response.status === 200) {
            msg.push({type: 'success', text: response.data.message})
        } else {
            msg.push({type: 'danger', text: response.data.message})
        }
    }

    if (response.data.messages && Array.isArray(response.data.messages)) {
        response.data.messages.forEach((message, index) => {
            msg.push({type: 'danger', text: message})
        });
    }

    if (response.data.error !== undefined) {
        $.each(response.data.error, function (k, error) {
            if ($('#' + k).length > 0) {
                $('#' + k).addClass('error')
            }
            msg.push({type: 'danger', text: error})
        })
    } else {
        target.modal('hide');
        target = $("#notifications");
    }

    if (target.hasClass('modal')) {
        target = target.find('.modal-alerts').first();
    }

    if (msg.length > 0) {
        showNotifications(msg, target);
    }
}

/**
 *
 * @param messages
 * @param target
 */
let showNotifications = function(messages, target) {
    if (target === undefined) {
        target = $("#notifications");
    }

    target.html('');

    $.each(messages, function (key, msg) {
        target.append('<div class="alert alert-' + msg.type + '" role="alert">' + msg.text + '</div>');
    })
    target.removeClass('d-none');

    setTimeout(() => {
        target.addClass('d-none');
    }, "5000");
}

/**
 *
 * @param departmentId
 */
let loadDepartmentCertificates = function(departmentId) {
    axios.get('/get-department-certificates', {
        params: {
            department_id: $('#department_id').val()
        },
    }).then(function (response) {
        $('#department-certificate-wrapper .loading-spinner').addClass('d-none');
        $('.department-certificates').html(response.data);
    }).catch(function (error) {
        console.error(error);
    });
}

/**
 *
 */
let loadCompanyCertificates = function () {
    $('#company-certificates-wrapper').html('');
    axios.get('/get-company-certificates', {
        params: {
            sort: false
        },
    }).then(function (response) {
        $('#company-certificates-wrapper').html(response.data);
        $('.link').on('click', function () {
            if ($(this).data('target')) {
                window.location.href = $(this).data('target');
            }
        })
    }).catch(function (error) {
        console.error(error);
    });
}

let loadTimeline = function() {
    $('#timeline-wrapper').html('');
    axios.get('/get-timeline-view', {
        params: {
            id: $('#certificate_id').val()
        },
    }).then(function (response) {
        $('#timeline-wrapper').html(response.data.html);
        $('.edit-state').on('click', function () {
            axios.get('/get-state', {
                params: {
                    state_id: $(this).data('state-id')
                },
            }).then(function(response) {
                let state = response.data.state;
                $('#state_upload').show();
                $('#state-form').trigger('reset');
                $('#state_id').val(state.id);
                $('#state_certificate_id').val(state.department_certificate_id);
                $('#state_user_id').val(state.user_id);
                $('#state_state').val(state.state);
                $('#state_valid').val(state.state_valid);
                if (state.file !== null) {
                    $('#uploaded-file').text(state.file.filename)
                    $('#delete-file').data('file-id', state.file.id)
                    $('.state-upload-wrapper').addClass('d-none');
                    $('.state-uploaded-wrapper').removeClass('d-none');
                }
                $('#newCertificateStateModal').modal('show');
            }).catch(function (error) {
                console.error(error);
            });
        })

    }).catch(function (error) {
        console.error(error);
    });
}


/**
 *
 * @param target
 * @param response
 */
let showAjaxAlert = function(target, response) {
    if (response.status !== undefined && response.status === 200 && response.data.result.success !== undefined) {
        target.append('<div class="alert alert-info" role="alert">' + response.data.result.success + '</div>')
    } else {
        $.each(response.data.result.error, function (errKey, errVals) {
            $.each(errVals, function (errKey, errVal) {
                target.append('<div class="alert alert-danger" role="alert">' + errVals + '</div>');
            });
        })
    }
}
